export default {
  "remove": "Odstrani",
  "save": "Shrani",
  "open": "Odpri",
  "edit": "Uredi",
  "cancel": "Prekliči",
  "search.placeholder": "Išči ...",

  "codelist": {
    "title": "Šifranti",
    "add": "Dodaj",
    "import": "Naloži",
    "list": {
      "key": "Ključ",
      "value": "Vrednost",
      "updated": "Posodobljeno",
      "created_at": "Ustvarjeno",
      "data": "Podatki",
      "title": "Naslov",
      "color": "Barva",
      "icon": "Ikona",
      "document_category_id": "Kategorija dokumenta",
      "name": "Ime",
      "profile_id": "Profil",
      "country_code": "Koda države",
      "male_title": "Moški naziv",
      "female_title": "Ženski naziv",
      "education_program_id": "Področje izobrazbe",
      "equipment_category_id": "Kategorija",
      "country_id": "Država",
      "date": "Datum",
      "view_id": "Modul",
      "address": "Naslov",
      "postal": "Poštna številka",
      "city": "Mesto",
      "contact": "Kontakt",
      "phone": "Telefon",
      "email": "E-pošta"
    },
    "category": {
      "title": "Kategorije",
      "list": {
        "title": "Naslov",
        "define.schema": "Definiraj shemo",
        "define.schema.desc": "Ali posamezni vnos vsebuje vec vrednosti",
        "schema": "Shema",
        "remove": "Odstrani kategorijo",
        "edit": "Uredi kategorijo",
        "new": "Nova kategorija",
        "save": "Shrani kategorijo",
        "add": "Dodaj kategorijo"
      },
      "one.document": "dokument",
      "two.documents": "dokumenta",
      "3-4.documents": "dokumenti",
      "many.documents": "dokumentov",
      "msg": {
        "remove": "Ste prepsičani da želite odstraniti kategorijo",
        "wrong.schema": "Podatkovna shema je napacna",
        "saved": "Kategorija uspešno shranjena",
        "empty": "Šifranti so prazni. Ustvari svojo prvo kategorijo in vnesi podatke"
      }
    },
    "msg": {
      "removed": "Podatki si bili uspešno odstranjeni.",
      "updated": "Podatki posodobljeni",
      "remove.error": "Med odstranjevanjem podatkov je prišlo do napake"
    }
  },
  "msg": {
    "save.error": "Med odstranjevanjem kategorije je prišlo do napake"
  },
  "document": {
    "category": {
      "rating-center": "Ocenjevalni center",
      "rating-center/candidate": "Ocenjevalni center - Kandidat",
      "company": "Podjetje",
      "candidate": "Kandidat",
      "user-portal/download": "Uporabniški portal - Prenos",
      "cover": "Cover stran"
    }
  },
  "measure": {
    "ContentTree": {
      "title": "Organigram podjetja",
      "description": "Struktura oddelkov in seznam zaposlenih v podjetju",
      "units": "Oddelki",
      "employees": "Zaposleni",
      "content": "Vsebina",
      "edit": "Uredi",
      "import_data": "Uvoz podatkov",
      "download_structure": "Prenos strukture",
      "new_subnode": "Podkategorija",
      "delete": "Izbriši",
      "close": "Zaključi urejanje"
    }
  },
  "UIK": {
    "components": {
      "universal": {
        "table": {
          "paginate": {
            "next": "Naprej",
            "previous": "Nazaj"
          }
        }
      }
    }
  }
}
